import { createAuthClient } from 'better-auth/react'
import { API_BASE_URL } from '@/lib/env'

export const betterAuthClient = createAuthClient({
  baseURL: API_BASE_URL,
  basePath: '/api/auth',
  fetchOptions: {
    credentials: 'include',
  },
})
